import {
  GET_SPOT_OPEN_ORDERS_REQUEST,
  GET_SPOT_OPEN_ORDERS_SUCCESS,
  GET_SPOT_OPEN_ORDERS_ERROR,
  REMOVE_SPOT_OPEN_ORDERS,
  GET_SPOT_ORDER_HISTORY_REQUEST,
  GET_SPOT_ORDER_HISTORY_SUCCESS,
  GET_SPOT_ORDER_HISTORY_ERROR,
  REMOVE_SPOT_ORDER_HISTORY,
} from "../../ActionTypes/SpotHistoryActionTypes.js";

const initialState = {
  loading: false,
  data: [],
  error: null,
  status: null,
  orderHistoryLoading: false,
  orderHistoryData: [],
  orderHistoryError: null,
  orderHistoryStatus: null,
};

const spotOpenOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SPOT_OPEN_ORDERS_REQUEST:
      return { ...state, loading: true, status: null, error: null };

    case GET_SPOT_OPEN_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: true,
        error: null,
      };

    case GET_SPOT_OPEN_ORDERS_ERROR:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
        status: false,
      };

    case REMOVE_SPOT_OPEN_ORDERS:
      return { ...initialState };
    // order history


    case GET_SPOT_ORDER_HISTORY_REQUEST:
      return { ...state, orderHistoryLoading: true, orderHistoryStatus: null, orderHistoryError: null };

    case GET_SPOT_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        orderHistoryLoading: false,
        orderHistoryData: action.payload,
        orderHistoryStatus: true,
        orderHistoryError: null,
      };

    case GET_SPOT_ORDER_HISTORY_ERROR:
      return {
        ...state,
        orderHistoryLoading: false,
        orderHistoryData: null,
        orderHistoryError: action.payload,
        orderHistoryStatus: false,
      };

    case REMOVE_SPOT_ORDER_HISTORY:
      return { ...initialState };



    default:
      return state;
  }
};

export default spotOpenOrdersReducer;
